import React, { useEffect, useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { Link } from "react-router-dom";
import { getAnnouncements } from "services/announcements";

interface Announcement {
  id: number;
  title: string;
  content: string;
  body?: string;
  creator?: { firstname?: string; lastname?: string; name?: string };
  created_at?: string;
}

const UserAnnouncements = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getAnnouncements();
        setAnnouncements(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error(err);
        setAnnouncements([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Card extra="w-full p-4">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Announcements</h1>
        <div className="hidden sm:block">
          <Button
            as="link"
            to="/user/announcements"
            variant="neutral"
            size="sm"
          >
            All Announcements
          </Button>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : announcements.length === 0 ? (
        <p className="text-gray-500">No announcements available.</p>
      ) : (
        <div className="space-y-4">
          {announcements.map((a) => (
            <article
              key={a.id}
              className="rounded-lg bg-white p-4 shadow-sm dark:bg-navy-700"
            >
              <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                <div>
                  <h2 className="text-lg font-semibold">{a.title}</h2>
                  <p className="mt-1 text-xs text-gray-400">
                    {a.created_at ? new Date(a.created_at).toLocaleString() : ""}
                    {a.creator ? (
                      <span className="ml-3">by {a.creator.firstname || a.creator.name}</span>
                    ) : null}
                  </p>
                  <p className="mt-2 line-clamp-3 text-sm text-gray-600 dark:text-gray-300">
                    {a.body ?? a.content}
                  </p>
                </div>
                <div className="mt-3 md:mt-0">
                  <Link to={`/announcements/${a.id}`}>
                    <Button size="sm" variant="outline">
                      View
                    </Button>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </Card>
  );
};

export default UserAnnouncements;
